import { render, staticRenderFns } from "./SettingsLeftSideBar.vue?vue&type=template&id=7622ccbc&scoped=true"
import script from "./SettingsLeftSideBar.vue?vue&type=script&lang=js"
export * from "./SettingsLeftSideBar.vue?vue&type=script&lang=js"
import style0 from "./SettingsLeftSideBar.vue?vue&type=style&index=0&id=7622ccbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622ccbc",
  null
  
)

export default component.exports